import { render, staticRenderFns } from "./AsdInsurances.vue?vue&type=template&id=762026b6&scoped=true"
import script from "./AsdInsurances.vue?vue&type=script&lang=js"
export * from "./AsdInsurances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762026b6",
  null
  
)

export default component.exports